import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_MY_METRICS_LIST_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { myMetricsFailure, myMetricsSuccess } from '../actions';

const myMetricsAPI = (action) => postApiRequest(`${VENDOR_MY_METRICS_LIST_API_URL}?VendorId=${action}`);

function* handlemyMetricsAPI(action) {
  try {
    const response = yield call(myMetricsAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(myMetricsSuccess(response));
  } catch (error) {
    yield put(myMetricsFailure(error));
  }
}

export function* watchMyMetrics() {
  yield takeLatest(types.GET_MY_METRICS_LIST_REQUEST, handlemyMetricsAPI);
}
